import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';

function CryptoPayment() {
  const { invoiceId } = useParams();

  useEffect(() => {
    if (invoiceId) {
      // Redirect to the external receipt page
      window.location.href = `https://cbthost.com/payment/receipt/${invoiceId}`;
    } else {
      console.error('No invoice ID provided');
      // Optional: redirect to a fallback page or show an error message
      // window.location.href = '/cbt_creator/payment';
            window.location.href = `https://cbthost.com/payment/receipt/${invoiceId}`;
    }
  }, [invoiceId]);

  // Show a loading message while redirecting
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-gray-50 to-blue-50">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
        <p className="mt-4 text-gray-600">Redirecting to receipt page...</p>
      </div>
    </div>
  );
}

export default CryptoPayment;